import React from 'react';
import Hero from './components/proceedings/Hero'
import Main from './components/proceedings/Main';

const Proceedings = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Proceedings;